if (!customElements.get('geosort-story-navigation')) {
  const catalogs = new Map();
  customElements.define('geosort-story-navigation', class extends HTMLElement {
    static neighbors(stories, current) {
      const index = stories.findIndex(story => story.path === current);
      if (index < 0 || stories.length < 2) return [];
      return [stories[(index + stories.length - 1) % stories.length], stories[(index + 1) % stories.length]];
    }
    connectedCallback() {
      this.load();
    }
    async load() {
      try {
        const source = new URL(this.dataset.source, location.origin);
        if (source.origin !== location.origin) return;
        // Read the published listing on each page visit, never a stale localStorage copy.
        if (!catalogs.has(source.href)) {
          catalogs.set(source.href, fetch(source.href, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) })
            .then(response => {
              if (!response.ok) throw new Error('Growth Stories could not load');
              return response.text();
            }).then(html => {
              const page = new DOMParser().parseFromString(html, 'text/html');
              const seen = new Set();
              return [...page.querySelectorAll('geosort-growth-stories [data-growth-story-url]')].flatMap(card => {
                if (!card.dataset.growthStoryUrl || card.hidden) return [];
                const url = new URL(card.dataset.growthStoryUrl, location.origin);
                if (url.origin !== location.origin || seen.has(url.pathname)) return [];
                seen.add(url.pathname);
                return [{ ...card.dataset, path: url.pathname.replace(/\/$/, ''), url: url.href }];
              });
            }));
        }
        const stories = await catalogs.get(source.href);
        if (!this.isConnected) return;
        const current = new URL(this.dataset.current || location.pathname, location.origin).pathname.replace(/\/$/, '');
        const neighbors = this.constructor.neighbors(stories, current);
        // Keep the server-rendered links if the catalog is temporarily unavailable.
        if (neighbors.length !== 2) return;
        const cards = neighbors.map((story, index) => this.card(story, index === 0 ? 'previous' : 'next'));
        this.querySelector('nav').replaceChildren(...cards);
        this.dataset.catalogCount = stories.length;
      } catch (error) {
        catalogs.delete(new URL(this.dataset.source, location.origin).href);
      }
    }
    card(story, direction) {
      const card = this.querySelector('[data-story-card]').content.firstElementChild.cloneNode(true);
      const link = card.querySelector('a');
      const label = this.dataset[`${direction}Label`];
      link.href = story.url;
      link.rel = direction === 'previous' ? 'prev' : 'next';
      link.classList.add(`gsn-story--${direction}`);
      link.setAttribute('aria-label', `${label}: ${story.brand}`);
      card.style.setProperty('--gsn-position', story.position || 'center');
      card.style.setProperty('--gsv-position', story.position || 'center');
      card.querySelector('[data-direction-label]').textContent = label;
      card.querySelector('p').textContent = story.summary.replace(/\s+/g, ' ').trim();
      const photo = card.querySelector('.gsn-photo img');
      if (story.photo) photo.src = story.photo;
      else { photo.parentElement.remove(); link.classList.add('gsn-story--no-photo'); }
      const logo = card.querySelector('.gsn-logo');
      if (story.logo) { logo.src = story.logo; logo.alt = story.brand; }
      else logo.parentElement.textContent = story.brand;
      if (story.video && story.photo) {
        const player = this.querySelector('[data-story-player]').content.firstElementChild.cloneNode(true);
        player.dataset.brand = story.brand;
        const video = player.querySelector('video');
        video.dataset.src = story.video;
        video.poster = story.photo;
        const slot = card.querySelector('.gsn-video-slot');
        slot.hidden = false;
        slot.append(player);
      }
      return card;
    }
  });
}
